
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","clip-path":"url(#clip0_75_1554)"}},[_c('path',{attrs:{"d":"M22 8.824v9.5c0 1.13-.9 2.055-2 2.055H4c-1.1 0-2-.925-2-2.055l.006-9.496L12 15.243l10-6.42zm-2-4.879c1.1 0 2 .925 2 2.054v.183l-10 6.42-9.991-6.414L2.01 6c0-1.067.794-1.95 1.809-2.045L4 3.945h16z","fill":"#262626"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_75_1554"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 3.945)","d":"M0 0h20v16.69H0z"}})])])])
          )
        }
      }
    